import quoteIcon from "@assets/icons/quote.svg";
import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import Image from "@elements/ResponsiveImage/Image";
import { DEFAULT_COLOR } from "@helper/sectionConstants";
import { ProcessedTextElement } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type PullQuoteCardProps = {
  quote: ProcessedTextElement;
  quotee: ProcessedTextElement;
  quoteCredit: ProcessedTextElement | undefined;
  sectionColor?: string;
};

export default function PullQuoteCard({
  quote,
  quotee,
  quoteCredit,
  sectionColor,
}: PullQuoteCardProps) {
  const flexCol = "flex flex-col lg:flex-row";

  return (
    <div
      className={twMerge("py-6 font-primary px-3 md:px-5 lg:px-0", flexCol)}
      style={{
        color: sectionColor ? sectionColor : DEFAULT_COLOR,
      }}
    >
      <Image
        src={quoteIcon}
        srcWidth={140}
        srcHeight={90}
        alt={"quote-icom"}
        loading="lazy"
        className="h-20 lg:h-[90px] w-24 lg:w-[140px] !object-contain"
      />
      <div className="lg:gap-3 lg:inline-grid">
        <div
          className={twMerge(
            "font-bold lg:font-semibold text-3xl lg:text-100 leading-9 lg:leading-11",
            flexCol,
          )}
        >
          {ApplyParagraphAnnotations(quote.value, quote.annotations)}
        </div>
        <div
          className={twMerge(
            "text-base leading-6 font-bold font-opensans",
            flexCol,
          )}
        >
          <span>
            {ApplyParagraphAnnotations(quotee.value, quotee.annotations)}
          </span>
          {quoteCredit && quoteCredit.value && (
            <span>
              {ApplyParagraphAnnotations(
                quoteCredit.value,
                quoteCredit.annotations,
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
